<template>
  <div class="user-center__access-record-container user-center__common-child-container">
    <SubPageHeader>
      <template #title>
        <router-link
          tag="div"
          :to="nav.url"
          active-class="active"
          class="title__front-item"
          v-for="(nav, index) in breadcrumbs"
          :key="index"
          >{{ nav.name }}</router-link
        >
      </template>
    </SubPageHeader>
    <div class="access-record__main-body promote-c">
      <h3 style="color: #fabe00;">积分使用说明：商家充值积分可用在平台推广使用，可在下方根据自己的实际情况进行选择。</h3>
      <div class="jf-c">
        <h2>当前积分</h2>
        <p class="flex-between">
          <span>当前剩余积分：</span>
          <span>{{ userIntegral.integral }}</span>
        </p>
        <p class="flex-between">
          <span>积分累计充值：</span>
          <span>{{ userIntegral.totalIntegralLog }}</span>
        </p>
        <div style="text-align: right;padding: 30px 0 20px;">
          <span class="bt-c" @click="onConfirm">立即充值</span>
        </div>
      </div>
      <div class="tg-c">
        <h3>推广助力</h3>
        <span class="circle-c"></span>
        <span>选择要推广的类型和面向人群，即可发送对应消息给平台用户消息列表，触达更精准！</span>
      </div>
      <div class="tg-item-c">
        <h4>选择要推广的类型：</h4>
        <span class="tg-item-span-c" :class="{'active': activeType == item.id}" v-for="(item, index) in typeOpe" :key="index" @click="activeType = item.id, onClickType()">{{item.value}}</span>
      </div>
      <div class="tg-item-c">
        <h4>选择要推广的人群：</h4>
        <span class="tg-item-span-c" :class="{'active': activePer == item.id}" 
        v-for="(item, index) in personOpe" :key="index" @click="activePer = item.id, num = 1">{{item.value}}</span>
      </div>
      <div class="tg-item-c">
        <h4>填写要推广的数量：</h4>
        <el-input-number size="mini" :precision="0" v-model="num" :min="1" controls-position="right" 
        :max="maxNum"></el-input-number>
      </div>
      <div class="tg-item-c" style="border-bottom: unset;">
        <h4>本次推广积分合计：</h4>
        <span style="color: red;font-size: 14px;border: unset;padding: 0 8px 0 10px;">{{ promoteIntegral*num }}</span>积分
      </div>
      <div style="text-align: right;padding: 0px 0 20px;border-bottom: 5px solid #eee;line-height: 40px;">
        <span class="bt-c" @click="onSubmit">提交推广</span>
      </div>

      <div class="tg-c">
        <h3 style="width: 206px;">入驻到设计企业的推荐商家库</h3>
        <span class="circle-c"></span>
        <span>选择产品对口的设计企业，即可被推荐到该设计企业的商家库里。</span>
      </div>
      <div class="tg-item-c">
        <h4>选择设计企业：</h4>
         <el-select style="width: 100%;" size="mini" v-model="comp" filterable multiple placeholder="请选择">
          <el-option
            v-for="item in companylist"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="tg-item-c" style="border-bottom: unset;">
        <h4>本次推广积分合计：</h4>
        <span style="color: red;font-size: 14px;border: unset;padding: 0 8px 0 10px;">{{ comp.length > 0 ? (comp.length * comIntegral) : comIntegral}}</span>
        积分
        <!-- （每家每年） -->
      </div>
      <div style="text-align: right;padding: 0px 0 20px;line-height: 40px;">
        <span class="bt-c" @click="onSubmit2">提交推广</span>
      </div>
     
    </div>

    <el-dialog
      custom-class="radio-dia-c"
      :title="`${activeType == 2 ? '请选择要推广的案例' : '请选择要推广的产品'}`"
      :visible.sync="dialogVisible"
      width="670px"
      :before-close="handleClose">
      
      <div style="min-height: 256px;">
       
        <div v-if="list.length > 0">
          <el-radio-group v-model="id">
            <el-radio class="flex-between" v-for="(item, index) in list" :label="item.id" :key="index" @change="onChange">
                <span class="ellipsis1">{{item.title || item.name}}</span>
            </el-radio>
          </el-radio-group>

          <!-- <el-checkbox-group v-model="checkedCities">
            <el-checkbox v-for="(item, index) in list" :label="item.title" :key="index">
              <span class="ellipsis1">{{item.title}}</span>
            </el-checkbox>
          </el-checkbox-group> -->
        </div>


        <div class="abs-center" v-else>
          您还没有上传过{{ activeType == 2 ? '案例' : '产品'}}，请先上传{{ activeType == 2 ? '案例' : '产品'}}后再试！
        </div>
      </div>

      <div style="padding: 20px 0 0;" v-if="list.length > 0">
        <!-- <pagination
          class="component-pagination"
          :config="paginationConfig"
        ></pagination> -->
        <el-pagination
          background
          layout="total,prev, pager, next"
          :total="paginationConfig.num"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange">
        </el-pagination>
        <el-button style="float: right; margin-top: -30px;" size="mini" type="primary" @click="onSelect()">确 定</el-button>
      </div>

      <!-- <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="handleClose">取 消</el-button>
        <el-button size="mini" type="primary" @click="onSelect()">确 定</el-button>
      </span> -->
    </el-dialog>
    
    <el-dialog custom-class="tg-dialog radio-dia-c" title="推广成功" :visible.sync="showTable" width="600px">
      <div class="cart__main-body">
        <p style="border-bottom: 1px solid #eee;padding-bottom: 10px;">您选择的内容已推广至<span style="color: red;">{{tableList.length}}</span>位用户消息列表中，请耐心等待回应！</p>
        <el-table
          :data="tableList1"
          style="width: 100%">
          <el-table-column
            prop="nickname"
            label="用户昵称"
            width="150"
            :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column
            prop="prov_name"
            label="城市"
            width="80"
            :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column
            prop="promote_people_name"
            label="身份"
            width="100"
            :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column
            prop="company"
            label="所在公司"
            :show-overflow-tooltip="true">
          </el-table-column>
        </el-table>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :total="tableList.length"
          @current-change="onCurrentChange">
        </el-pagination>
        <el-button style="float: right; margin-top: -30px;" type="primary" size="mini" @click="showTable = false">确定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Empty from '@/pages/common/empty.vue';
import { scrollToUp } from '@/assets/utils/common';
import { integralDetailed, getPromoteIntegral, promoteUser, getUserIntegralInfo, getDesignCompanylist,
 promoteDesignCompany, getDesignCompanyIntegralInfo, getPromoteCaseList, getPromoteProductList } from '@/api/user';
import Pagination from '@/components/pagination.vue';
import SubPageHeader from '../_pageHeader.vue';
import { myList } from '@/api/case';
import { myProducts } from '@/api/product';

export default {
  components: {
    SubPageHeader,
    Pagination,
    Empty,
  },
  data() {
    return {
      breadcrumbs: [
        {
          name: '积分推广',
          url: '/my/promote',
        },
        {
          name: '积分消耗报告',
          url: '/my/integral',
        },
      ],
      page: 1,
      pageSize: 10,
      paginationConfig: {},
      requesting: false,
      showPage: false,
      integral: 0,
      cumulative_integral: 0,
      typeOpe: [
        {
          id: 1,
          value: '店铺',
        }, 
        {
          id: 2,
          value: '案例',
        }, 
        {
          id: 3,
          value: '产品',
        }, 
      ],
      personOpe: [
         {
          id: 1,
          value: '设计企业',
        }, 
        {
          id: 2,
          value: '设计师',
        }
      ],
      num: 1,
      comp: [],
      activeType: 1,
      activePer: 1,
      userIntegral: {},
      promoteIntegral: 0, //每人推广积分
      list: [],
      myList: [],
      proList: [],
      companylist: [],
      dialogVisible: false,
      radio: '',
      id: '',
      checkedCities: [],
      comIntegral: 0,
      designCompanyMaxNum: 0,
      designerMaxNum: 0,
      showTable: false,
      tableList: [],
      curPage: 1,
    };
  },
  computed: mapState({
    userInfo: ({ user: { info } }) => info,
    maxNum() {
      let num = this.activePer == 1 ? this.designCompanyMaxNum : this.designerMaxNum
      return num
    },
    tableList1() {
      return this.tableList.slice((this.curPage - 1) * 10, 10 * this.curPage)
    }
  }),
  watch: {
    $route: {
      handler: 'init',
      immediate: true,
    },
  },
  methods: {
    async init() {
      if(this.userInfo.type == 4) {
        this.breadcrumbs.pop()
      }
      console.log(this.userInfo, 666)
      // 获取数据
      this.$store.commit('openLoading');
      
      this.getUserIntegralInfo()

      let res2 = await getPromoteIntegral({});
      this.promoteIntegral = res2.data.integral || 0
      this.designCompanyMaxNum = res2.data.designCompanyMaxNum || 0
      this.designerMaxNum = res2.data.designerMaxNum || 0
      let res3 = await getDesignCompanylist({});
      this.companylist = res3.data.list || []
      let res4 = await getDesignCompanyIntegralInfo({});
      this.comIntegral = res4.data.integral || 0

      this.$store.commit('closeLoading');
    },
    async getUserIntegralInfo() {
      let res = await getUserIntegralInfo({});
      this.userIntegral = res.data || {}
      let userInfo = this.userInfo
      userInfo.integral = this.userIntegral.integral
      this.$store.commit('user/SET_INFO', userInfo);
    },
    async onSubmit() {
      if(this.userIntegral.integral < this.promoteIntegral * this.num) {
        this.$message({
          type: "error",
          message: `您的积分不够，请去充值`
        });
        return
      }
      this.$store.commit('openLoading');
      if(this.activeType == 1) {
        this.id = this.userInfo.store_id
      }
      if(!this.id) {
        this.$message({
          type: "error",
          message: `请选择您已发布的${this.activeType == 2? '案例' : '产品'}`
        });
        return
      }
      let params = {
        id: this.id,
        promote_type: this.activeType,
        promote_people: this.activePer,
        promote_people_num: this.num,
      }
      let res = await promoteUser(params);
      this.tableList = res.data.list
      this.getUserIntegralInfo()
      this.showTable = true
      this.$store.commit('closeLoading');
    },
    async onSubmit2() {
      if(this.comp.length == 0) {
        this.$message({
          type: "error",
          message: "请选择设计企业"
        });
        return
      }
      if(this.userIntegral.integral < this.comp.length * this.comIntegral) {
        this.$message({
          type: "error",
          message: `您的积分不够，请去充值`
        });
        return
      }
      this.$store.commit('openLoading');
      let params = {
        recommend_store_ids: this.comp,
      }
      let res = await promoteDesignCompany(params);
      if(res.success) {
        // this.$message({
        //   type: "success",
        //   message: res.desc
        // });
        this.getUserIntegralInfo()
        this.$alert(`您的选项已提交，管理员审核成功后会将您的店铺推荐至商家库`, '审核提示', {
          confirmButtonText: '确定',
          callback: action => {
            if(action == 'confirm') {
              
            }
          }
        });
      }else{
        this.$message({
          type: "error",
          message: res.desc
        });
      }
      this.$store.commit('closeLoading');
    },
    async onClickType(){
      this.id = ''
      if(this.activeType != 1) {
        this.list = []
        await this.handleCurrentChange(1)
      }
    },
    handleClose() {
      this.dialogVisible = false
      this.$set(this, 'id', '')
    },
    async getLists() {
      // 获取数据
      this.$store.commit('openLoading');
      const res = await getPromoteCaseList({
        page: this.page,
        page_size: this.pageSize,
        // status: 1, // 审核通过的 
      });
      const { data } = res;
      this.list = this.myList = [...data.list];
      this.paginationConfig.num = data.total;
      this.dialogVisible = true
      this.$store.commit('closeLoading');
    },
    async getMyProducts() {
      console.log()
      this.$store.commit('openLoading');
      const res = await getPromoteProductList({
        page: this.page,
        page_size: this.pageSize,
      });
      const { data } = res;
      this.paginationConfig.num = data.total;
      this.list = this.proList = data.list;
      this.dialogVisible = true
      this.$store.commit('closeLoading');
    },
    handleSizeChange(val) {
      console.log(val, 'Size')
    },
    handleCurrentChange(val) {
      this.page = val
      if(this.activeType == 2) {
        this.getLists()
        }else{
        this.getMyProducts()
      }
    },
    onChange(val) {
      console.log(val, 'onChange')
    },
    onSelect() {
      if(!this.id) {
         this.$message({
          type: "error",
          message: `请选择!`
        });
      }else{
        this.dialogVisible = false
      }
    },
    onConfirm() {
      window.open("https://store.clzx.net/index.php?ctl=Product&met=detail&item_id=1984"); 
    },
    onCurrentChange(val) {
      this.curPage = val
    }
  },
};
</script>

<style lang="scss">
  .user-center__access-record-container {
    padding-bottom: 20px;
  }
  .promote-c {
    h3 {
      font-size: 15px;
      font-weight: 500;
      line-height: 60px;
    }
    .jf-c {
      width: 100%;
      border-top: 5px solid #eee;
      border-bottom: 5px solid #eee;
      line-height: 40px;
      font-weight: 600;
      h2 {
        font-size: 14px;
        border-bottom: 1px solid #eee;
      }
      p {
        border-bottom: 1px solid #eee;
      }
      span {
        width: 50%;
      }
    }
    .tg-c {
      border-bottom: 1px solid #eee;
      h3 {
        display: inline-block;
        width: 70px;
        font-size: 15px;
        font-weight: 600;
      }
      .circle-c{
        width: 8px;
        height: 8px;
        background: #fabe00;
        border-radius: 50%;
        display: inline-block;
        margin-right: 6px;
      }
    }
    .tg-item-c {
      border-bottom: 1px solid #eee;
      padding-bottom: 20px;
      h4 {
        line-height: 40px;
      }
      .tg-item-span-c {
        border: 1px solid #eee;
        padding: 4px 20px;
        margin-right: 10px;
        cursor: pointer;
      }
      .active {
        background: #fabe00;
        color: #fff;
      }
    }
    .line-p {
      width: 100%;
      height: 1px;
      background: #eee;
    }
    .bt-c{
        background: #fabe00;
        border-radius: 14px;        
        text-align: center;
        cursor: pointer;
        color: #333;
        font-weight: 600;
        padding: 6px 16px;
        font-size: 14px;
      }
  }
  .radio-dia-c {
     margin-top: 28vh !important;
    .el-dialog__body {
      // padding: 20px !important;
      min-height: 320px;
      // overflow-y: auto;
      .abs-center {
        width: 100%;
        text-align: center;
      }
      .ellipsis1 {
        width: 552px;
        line-height: 25px;
        display: inline-block !important;
      }
    }
    .el-radio {
      line-height: 25px;
      display: block;
      margin-right: 0;
      .el-radio__input {
        vertical-align: super;
      }
    }
    .component-pagination {
      margin-top: 20px;
    }
    .el-checkbox {
      display: block;
      line-height: 25px;
      .el-checkbox__input {
        vertical-align: super;
      }
    }
    .el-pagination {
      text-align: center;
      .active {
        background: #fabe00 !important;
        &:hover {
          color: #fff !important;
        }
      }
      .el-pager li:not(.disabled):hover {
          color: #fabe00;
      }
      // .el-pager li:not(.disabled):hover {
      //     color: #fff;
      // }
    }
    .activeSelect {

    }
  }
  .el-message-box {
    width: 426px;
  }
  .tg-dialog {
    .el-dialog__body {
      padding-top: 0;
    }
    tr {
      line-height: 22px;
    }
    .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf {
        border-bottom: none;
    }
    .el-table__body-wrapper {
      height: 237px;
      overflow-y: auto;
      tr {
        td {
          padding: 0;
        }
      }
    }
    .el-table thead {
      color: #fabe00;
    }
  }
</style>
